import { createTheme } from "@comparaonline/ui-theme";

export const theme = createTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    primary: {
      50: "#C2D9FF",
      light: "#779BFF",
      main: "#4168FF",
      dark: "#103AD8"
    },
    secondary: {
      light: "#80F3BD",
      main: "#1CD880",
      contrastText: "#126941"
    },
    error: {
      50: "#FFF0F0",
      light: "#FFC4C4",
      main: "#FF4141",
      contrastText: "#B51616"
    },
    grey: {
      100: "#F8F8F8",
      200: "#F2F2F2",
      300: "#E6E6E6",
      400: "#CCCCCC",
      500: "#989898",
      600: "#666666",
      700: "#333333"
    }
  }
});
